import { Reference } from "@/lib/types";
import { ExternalLink } from "lucide-react";

interface ReferenceListProps {
  references: Reference[];
}

export default function ReferenceList({ references }: ReferenceListProps) {
  return (
    <ol className="space-y-3 list-none">
      {references.map((ref) => (
        <li key={ref.id} className="reference-item flex gap-3">
          <span
            className="flex-shrink-0 font-mono text-xs text-[var(--riee-gold-dark)] mt-0.5 w-5 text-right"
          >
            {ref.id}.
          </span>
          <span className="text-sm text-gray-700 leading-relaxed">
            {ref.text}
            {ref.doi && (
              <a
                href={ref.doi}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 ml-1 text-[var(--riee-purple)] hover:text-[var(--riee-gold-dark)] transition-colors text-xs"
              >
                <ExternalLink size={11} />
                DOI
              </a>
            )}
          </span>
        </li>
      ))}
    </ol>
  );
}
